module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.displayFields), function(field) {
    return _c('v-flex', _vm._b({
      key: field,
      staticClass: "pa-2",
      attrs: {
        "xs12": ""
      }
    }, 'v-flex', _vm.getWrapperAttrs(field), false), [_vm._t(field, function() {
      return [(_vm.fieldConfigs && _vm.fieldConfigs[field] && _vm.fieldConfigs[field].type === "vtextarea") ? _c('v-textarea', _vm._b({
        attrs: {
          "outline": _vm.hasErrors(field),
          "label": field.replace(/_/g, ' '),
          "error-messages": _vm.getErrors(field)
        },
        model: {
          value: (_vm.data[field]),
          callback: function($$v) {
            _vm.$set(_vm.data, field, $$v)
          },
          expression: "data[field]"
        }
      }, 'v-textarea', _vm.fieldConfigs[field] || {}, false)) : _c('v-text-field', _vm._b({
        attrs: {
          "outline": _vm.hasErrors(field),
          "label": field.replace(/_/g, ' '),
          "error-messages": _vm.getErrors(field)
        },
        model: {
          value: (_vm.data[field]),
          callback: function($$v) {
            _vm.$set(_vm.data, field, $$v)
          },
          expression: "data[field]"
        }
      }, 'v-text-field', _vm.fieldConfigs[field] || {}, false)), _vm._v(" "), _vm._t((field + "-after"))]
    })], 2)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d8ecb8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/ObjectForm.vue
// module id = 1357
// module chunks = 9